import React from 'react';

export interface ICoinGeckoContext {
  starsUsdRate: number;
  starsEthRate: number;
  ethUsdRate: number;
  ethStarsRate: number;
  bnbUsdRate: number;
  bnbStarsRate: number;
  handleGetRates: () => void;
}

const defaultContext: ICoinGeckoContext = {
  starsUsdRate: 1,
  starsEthRate: 1,
  ethUsdRate: 1,
  ethStarsRate: 1,
  bnbUsdRate: 1,
  bnbStarsRate: 1,
  handleGetRates: () => {},
};

export const CoinGeckoContext: React.Context<ICoinGeckoContext> =
  React.createContext(defaultContext);
